import { FormValidatorBuilder } from '../../../../../validator/form-builder/FormValidatorBuilder.ts';
import { getParentValidationScope } from '../../../../../validator/utils/getParentValidationScope.ts';
import { type IWidgetType } from '../../../IWidgetType.ts';
import { type ISubsectionWidget } from './ISubsectionWidget.ts';

export const createSubsectionSchema: IWidgetType<ISubsectionWidget>['createFormSchema'] =
  ({ widget, section, page, parentScope }) => {
    const widgetScope = getParentValidationScope(widget, parentScope);
    // La sottosezione in sé non ha un valore, quindi inserisco tutti i suoi campi
    // all'interno del validatore come se fossero root
    return FormValidatorBuilder.createWidgetsSchemaShape(
      widget.children,
      section,
      page,
      widgetScope,
    );
  };
